
















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { faEllipsisH, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { Title } from '~/decorators/Title';
import SessionModule from '~/store/session';

@Component<Index>({
    layout: 'default',
})
@Title(process.env.NAME!)
export default class Index extends Vue {}
